module.exports = require("request-promise");


//////////////////
// WEBPACK FOOTER
// external "request-promise"
// module id = 3
// module chunks = 0 1